import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
export const ValueWithDiff = ({ value, ValueComponent, diffValue, DiffValueComponent, spacing, showDiff = true, flex, placeholder, }) => {
    const showValue = typeof value === "string" || typeof diffValue === "string";
    const valueToShow = value ? value : placeholder ? placeholder : " ";
    const showDiffValue = (diffValue || showDiff) && diffValue !== value;
    const diffValueToShow = showDiffValue
        ? diffValue
            ? diffValue
            : placeholder
                ? placeholder
                : ""
        : "";
    return (_jsxs(Stack, { direction: "column", spacing: spacing, flex: flex, children: [showValue &&
                (ValueComponent ? (_jsx(ValueComponent, { value: valueToShow })) : (_jsx("div", { children: valueToShow }))), showDiffValue && (_jsx(DiffedValue, { children: DiffValueComponent ? (_jsx(DiffValueComponent, { value: diffValueToShow })) : (_jsx("div", { children: diffValueToShow })) }))] }));
};
const DiffedValue = ({ children }) => {
    return (_jsx(Typography, { component: "div", style: {
            marginTop: `-2px`,
            color: "rgba(0, 0, 0, 0.58)",
            borderLeftStyle: "solid",
            borderLeftWidth: "1px",
            borderLeftColor: "rgba(0, 0, 0, 0.58)",
            paddingLeft: "4px",
            fontSize: "12px",
            fontStyle: "italic",
        }, variant: "body2", children: children }));
};
//# sourceMappingURL=DiffedValue.js.map